/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import { Box, Button, Snackbar, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import axios from "axios";
import config from "../../config";
import "./ReportingDashboard.css";

import BRSRDynamicForm from "./BRSRDynamicForm";

class ReportingGeneration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            cardTitle: "",
            framework: "BRSR",
            toast: { open: false, type: "info", msg: "" },
        };
    }

    async componentDidMount() {
        const cardId = this.props.match?.params?.id;
        this.fetchCardDetails(cardId);
    }

    fetchCardDetails = async (cardId) => {
        try {
            const res = await axios.get(`${config.laravelBaseUrl}reporting-dashboard/details/${cardId}`, {
                headers: { Authorization: "Bearer " + sessionStorage.getItem("userToken") },
            });
            const data = res.data?.data;
            if (data) {
                this.setState({
                    cardTitle: data.card_title,
                    framework: data.framework || "BRSR",
                    loading: false
                });
            }
        } catch (error) {
            console.error("Card details fetch failed:", error);
            this.setState({
                toast: { open: true, type: "error", msg: "Failed to load card details." },
                loading: false
            });
        }
    };

    render() {
        const { toast, cardTitle, framework, loading } = this.state;
        const cardId = this.props.match?.params?.id;

        return (
            <>
                <DashboardHeader />
                <div id="wrapper">
                    <DashboardSidebar />

                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/reporting/dashboard">Reporting</Link>
                                </li>
                                <li className="breadcrumb-item active">Report Generation</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap mt-2">
                                    <Typography variant="h6" style={{ fontWeight: 700 }}>
                                        Report Generation — {cardTitle || "Loading..."} ({framework})
                                    </Typography>

                                    <div className="mb-2 d-flex align-items-center no-print">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            style={{ marginRight: 8 }}
                                            onClick={() => this.props.history.push("/reporting/dashboard")}
                                        >
                                            <i className="fas fa-arrow-left mr-1"></i>
                                            Back
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            startIcon={<PictureAsPdfIcon />}
                                            onClick={() => window.print()}
                                        >
                                            Download PDF
                                        </Button>
                                    </div>
                                </div>

                                {!loading && (
                                    <BRSRDynamicForm
                                        cardId={cardId}
                                        financialYear="FY 2024-2025"
                                    />
                                )}
                            </div>
                        </div>

                        <FooterComponent />
                    </div>
                </div>

                <Snackbar
                    open={toast.open}
                    autoHideDuration={2500}
                    onClose={() => this.setState((prev) => ({ toast: { ...prev.toast, open: false } }))}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                    <Alert severity={toast.type} style={{ width: "100%" }}>
                        {toast.msg}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}

export default ReportingGeneration;
